<div class="flex flex-col h-full">
  <div class="p-8 flex flex-row justify-between items-center bg-primary-600 text-white rounded-t-md">
    <h2 class="m-0">{{ { key: 'onlineBooking' } | i18n }}</h2>
    <button class="flex flex-row justify-center items-center" (click)="close()">
      <ng-icon name="heroXMark" class="h-5 w-5 flex-shrink-0" size="24px"></ng-icon>
    </button>
  </div>
  <div class="rounded-b-md shadow-md bg-white p-8 w-full flex flex-col h-auto overflow-auto">
    @switch (displayMode()) {
      @case ('loggedOut') {
        <p>{{ { key: 'pleaseLogin' } | i18n }}</p>
        <button
          class="mt-8 w-full items-center justify-center rounded-md border border-transparent bg-primary-600 py-2 px-4 text-sm font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
          (click)="login()"
        >
          {{ { key: 'login' } | i18n }}
        </button>
      }
    }
  </div>
</div>
